import React from "react";

import moment from "moment";
import { element } from "prop-types";

const SimpleItemForDropDown = (
    {
        listItem,
        setState,
        setStateModel,
        field,
        itemClickHandler,
        property,
        array,
    }
) => {
    console.log(listItem);
    function selectHandler (event, listItem) {
        setState(() => listItem[property]);
        setStateModel((prev) => {
            if(array) {
                return {
                    ...prev,
                    [field]: [listItem.id],
                };
            }
            else {
                return {
                    ...prev,
                    [field]: listItem.id,
                };
            }

        });

        itemClickHandler(event, listItem);
    }

    return (
        <div
            className={"delegation-in-progress-item"}
            onClick={(event) => selectHandler(event, listItem)}>
            <div  className={"delegation-in-progress-item__fullname"}>
                {listItem[property]}
            </div>
        </div>
    );
};

export default SimpleItemForDropDown;
